import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FilterSelectProps {
  label: string;
  allLabel?: string;
  value: string;
  options: readonly string[];
  onChange: (value: string) => void;
  className?: string;
}
export function FilterSelect({
  label,
  allLabel,
  value,
  options,
  onChange,
  className = ''
}: FilterSelectProps) {
  const active = allLabel ? value !== 'All' : true;
  return <label className={`relative inline-flex ${className}`} data-id="element-1138" data-mp="14jzs8zqtbvaa">
      <span className="sr-only" data-id="element-1139" data-mp="14lkkujtkh45i">{label}</span>
      <select value={value} onChange={e => onChange(e.target.value)} className={`h-10 w-full cursor-pointer appearance-none rounded-xl border-0 bg-white pl-3.5 pr-9 text-sm ring-1 ring-inset transition focus:outline-none focus:ring-2 focus:ring-azure ${active && allLabel ? 'font-medium text-navy ring-azure/40' : 'text-slate-600 ring-slate-200'}`} data-id="element-1140" data-mp="19h9qn4w6jha9">
        {allLabel && <option value="All" data-id="element-1141" data-mp="3l8dovsaz1y4t">{allLabel}</option>}
        {options.map(o => <option key={o} value={o} data-id="element-1142" data-mp="3vjodwfjpxvje">
            {o}
          </option>)}
      </select>
      <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-1143" data-mp="3qrmwygblvgn1" />
    </label>;
}